import logger from '@/logger'

export class UrlHelpers {
  static getSafeReturnUrl(returnUrl: string | null, trustedUrls: string[] = []): string | null {
    if (!returnUrl) {
      logger.debug('getSafeReturnUrl', { returnUrl, result: null, reason: 'empty returnUrl' })
      return null
    }

    if (typeof window === 'undefined') {
      logger.debug('getSafeReturnUrl', { returnUrl, result: null, reason: 'window unavailable' })
      return null
    }

    try {
      const url = new URL(returnUrl, window.location.origin)
      const allowedOrigins = new Set([window.location.origin])

      for (const trustedUrl of trustedUrls) {
        if (trustedUrl) {
          const trustedOrigin = new URL(trustedUrl, window.location.origin).origin
          allowedOrigins.add(trustedOrigin)
        }
      }

      if ((url.protocol === 'http:' || url.protocol === 'https:') && allowedOrigins.has(url.origin)) {
        logger.debug('getSafeReturnUrl', { returnUrl, result: url.href, allowedOrigins: Array.from(allowedOrigins) })
        return url.href
      }

      logger.warn('getSafeReturnUrl blocked URL', {
        returnUrl,
        protocol: url.protocol,
        origin: url.origin,
        allowedOrigins: Array.from(allowedOrigins),
      })
    } catch (error) {
      logger.warn('getSafeReturnUrl invalid URL', { returnUrl, error })
      return null
    }

    return null
  }
}
